import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/icon_arrow_right.png';
import _imports_1 from '../../assets/home_img1.png';
import _imports_2 from '../../assets/home_img2.png';
import _imports_3 from '../../assets/device001.png';
import _imports_4 from '../../assets/device002.png';
import _imports_5 from '../../assets/device003.png';
import _imports_6 from '../../assets/device004.png';
import _imports_7 from '../../assets/blueCircle.png';
import _imports_8 from '../../assets/home_phone.png';
import _imports_9 from '../../assets/top3_img1.png';
import _imports_10 from '../../assets/top4.jpg';
import _imports_11 from '../../assets/top5_img1.png';
import _imports_12 from '../../assets/top5_img2.png';
import _imports_13 from '../../assets/top5_img3.png';
import _imports_14 from '../../assets/top6.jpg';
import _imports_15 from '../../assets/top7_img1.png';
import _imports_16 from '../../assets/top7_img2.png';
import _imports_17 from '../../assets/top7_img3.png';
import _imports_18 from '../../assets/top7_img4.png';
import _imports_19 from '../../assets/top7_img5.png';
import _imports_20 from '../../assets/top8.png';
import _imports_21 from '../../assets/top9_img1.png';
import _imports_22 from '../../assets/top9_img2.png';
import _imports_23 from '../../assets/top9_img3.png';

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-b9d245b4"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  id: "content"
};
var _hoisted_2 = {
  class: "top1"
};
var _hoisted_3 = {
  class: "top1_left"
};

var _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"top1_left_title animated fadeInUp\" data-v-b9d245b4> BC60墨水屏电子阅读器 </div><div class=\"top1_left_text1 animated fadeInUp\" data-v-b9d245b4>类纸全新阅读体验</div><div class=\"line_style animated fadeInUp\" data-v-b9d245b4><div class=\"line2\" data-v-b9d245b4></div><div class=\"line2\" data-v-b9d245b4></div><div class=\"line2\" data-v-b9d245b4></div></div>", 3);

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top1_btn_text"
  }, "了解更多", -1);
});

var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "arrow_right"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    style: {
      "width": "20px",
      "height": "15px"
    }
  })], -1);
});

var _hoisted_9 = [_hoisted_7, _hoisted_8];

var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top1_right animated fadeInRight"
  }, [/*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    class: "img1"
  })], -1);
});

var _hoisted_11 = {
  class: "top2"
};

var _hoisted_12 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top2_title"
  }, "产品展示", -1);
});

var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top2_text1"
  }, " BC60 Daystar ink screen e-reader product appearance display. ", -1);
});

var _hoisted_14 = {
  style: {
    "display": "flex",
    "justify-content": "space-between",
    "width": "100%",
    "align-items": "flex-start",
    "margin-top": "76px"
  }
};

var _hoisted_15 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "img2"
  }, null, -1);
});

var _hoisted_16 = {
  style: {
    "margin-left": "80px",
    "width": "50px"
  }
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "align"
  }, " BC60启明星电子阅读器致力于培养中少年健康阅读习惯 ", -1);
});

var _hoisted_18 = {
  style: {
    "display": "flex",
    "margin-top": "27px",
    "width": "100%"
  }
};
var _hoisted_19 = {
  class: "top2_block1"
};
var _hoisted_20 = {
  class: "top2_block2"
};

var _hoisted_21 = /*#__PURE__*/_createStaticVNode("<div class=\"top3\" data-v-b9d245b4><div class=\"blue_circle\" data-v-b9d245b4><img src=\"" + _imports_7 + "\" class=\"blue_img\" data-v-b9d245b4></div><div class=\"phone\" data-v-b9d245b4><img src=\"" + _imports_8 + "\" class=\"phone_img\" data-v-b9d245b4></div><div class=\"top3_text\" data-v-b9d245b4><div class=\"top3_text_title\" data-v-b9d245b4>配套软件智能检测</div><div class=\"top3_text_abs\" data-v-b9d245b4>自动记录设备使用情况</div><div class=\"top3_text_abs\" data-v-b9d245b4>分析阅读习惯数据</div><div class=\"top3_text_abs\" data-v-b9d245b4>内置海量图书免费畅读</div><div class=\"top3_text_abs\" data-v-b9d245b4>书库个人管理上传内容</div></div><div class=\"top3_img1\" data-v-b9d245b4><img src=\"" + _imports_9 + "\" class=\"top3img1\" data-v-b9d245b4><div class=\"top3_block1\" data-v-b9d245b4><div class=\"block1_content1\" data-v-b9d245b4><div class=\"content1_title\" data-v-b9d245b4>阅读总览</div><div class=\"content1_icon\" data-v-b9d245b4></div><div class=\"content1_abs\" data-v-b9d245b4> 可宏观查看设备的使用数据情况 <br data-v-b9d245b4> 并可比对大众用户使用情况 </div></div><div class=\"block1_content2\" data-v-b9d245b4><div class=\"content1_title\" data-v-b9d245b4>阅读习惯</div><div class=\"content1_icon\" data-v-b9d245b4></div><div class=\"content1_abs\" data-v-b9d245b4> 根据设备的使用时间及情况智能 <br data-v-b9d245b4> 分析设备的阅读习惯 </div></div><div class=\"block1_content3\" data-v-b9d245b4><div class=\"content1_title\" data-v-b9d245b4>阅读日历</div><div class=\"content1_icon\" data-v-b9d245b4></div><div class=\"content1_abs\" data-v-b9d245b4> 选择日期便可查看设备该日期 <br data-v-b9d245b4> 的使用数据及阅读数据 </div></div><div class=\"block1_content4\" data-v-b9d245b4><div class=\"content1_title\" data-v-b9d245b4>历史推送</div><div class=\"content1_icon\" data-v-b9d245b4></div><div class=\"content1_abs\" data-v-b9d245b4> 查看设备的读书数据统计设备 <br data-v-b9d245b4> 什么时间阅读的图书 </div></div></div></div></div><div class=\"top4\" data-v-b9d245b4><img src=\"" + _imports_10 + "\" class=\"top4_img\" data-v-b9d245b4><div class=\"top4_title\" data-v-b9d245b4> 类纸水墨屏 <span class=\"top4_title_span\" data-v-b9d245b4>X</span> 全新阅读感 </div><div class=\"top4_abs1\" data-v-b9d245b4> 阅读其实是一个寻找自我的过程。 摒弃成见，去从不同的角度体悟人生，然后再找到自己最喜欢的角度。 生命的一个意义，就在于寻找自己存在的意义，寻找自己的价值，寻找自己。 </div><div class=\"top4_abs2\" data-v-b9d245b4> 墨水屏类纸阅读体验，培养阅读习惯，让你爱上阅读！ </div><div class=\"top4_block1\" data-v-b9d245b4></div><div class=\"top4_block2\" data-v-b9d245b4></div></div>", 2);

var _hoisted_23 = {
  class: "top5"
};

var _hoisted_24 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top5_title"
  }, "产品信息", -1);
});

var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top5_abs"
  }, [/*#__PURE__*/_createTextVNode(" BC60 Daystar ink screen e-reader product appearance "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" display. ")], -1);
});

var _hoisted_26 = {
  class: "top5_block"
};

var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_11,
    class: "top5_img1"
  }, null, -1);
});

var _hoisted_28 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_12,
    class: "top5_img2"
  }, null, -1);
});

var _hoisted_29 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_13,
    class: "top5_img3"
  }, null, -1);
});

var _hoisted_30 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top5_block3"
  }, null, -1);
});

var _hoisted_31 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top5_text"
  }, [/*#__PURE__*/_createElementVNode("ul", {
    style: {
      "margin-left": "-24px"
    }
  }, [/*#__PURE__*/_createElementVNode("li", null, "国际唯一公认健康显示技术电子墨水屏阅读器"), /*#__PURE__*/_createElementVNode("li", null, " E-ink显示屏呈像原理同纸张印刷相似无自提供光源，反射成像、稳定显示、无光污染、无电子辐射。 "), /*#__PURE__*/_createElementVNode("li", null, " 内置多部中外字典词典、简明的百科全书及生词本等各种智慧学习系列工具，轻触即可使用笔记摘要阅读经历等云端储存电子纸阅读常见功能应有尽有。 ")])], -1);
});

var _hoisted_32 = /*#__PURE__*/_createStaticVNode("<div class=\"top6\" data-v-b9d245b4><img src=\"" + _imports_14 + "\" class=\"top6_img\" data-v-b9d245b4><div class=\"top6_title\" data-v-b9d245b4>让阅读陪伴孩子成长</div><div class=\"top6_abs1\" data-v-b9d245b4> 阅读其实是一个寻找自我的过程。 摒弃成见，去从不同的角度体悟人生，然后再找到自己最喜欢的角度。 生命的一个意义，就在于寻找自己存在的意义，寻找自己的价值，寻找自己。 </div><div class=\"top6_abs2\" data-v-b9d245b4> 墨水屏类纸阅读体验，培养阅读习惯，让你爱上阅读！ </div><div class=\"top6_block1\" data-v-b9d245b4></div><div class=\"top6_block2\" data-v-b9d245b4></div><div class=\"top6_block3\" data-v-b9d245b4></div><div class=\"top6_block4\" data-v-b9d245b4></div><div class=\"top6_block5\" data-v-b9d245b4></div></div>", 1);

var _hoisted_33 = {
  class: "top7"
};

var _hoisted_34 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top7_title"
  }, "产品特点", -1);
});

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top7_abs"
  }, [/*#__PURE__*/_createTextVNode(" Introduction to several functional features of the product "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" read. ")], -1);
});

var _hoisted_36 = {
  class: "top7_block"
};
var _hoisted_37 = {
  style: {
    "display": "flex",
    "width": "100%"
  }
};
var _hoisted_38 = {
  class: "top7_block1"
};

var _hoisted_39 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top7_block1_1"
  }, null, -1);
});

var _hoisted_40 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top7_block1_3"
  }, [/*#__PURE__*/_createTextVNode(" “ "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 阅读 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 全新体验 ")], -1);
});

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top7_block1_4"
  }, [/*#__PURE__*/_createTextVNode(" Paper-like ink, "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" a new reading experience ")], -1);
});

var _hoisted_42 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});

var _hoisted_43 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "top7_block1_5"
  }, [/*#__PURE__*/_createTextVNode(" 墨水屏还原书本阅读体验 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 机身轻薄小巧随声携带 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 辅助阅读功能模块应用 "), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 智能分析阅读数据情况 ")], -1);
});

var _hoisted_44 = /*#__PURE__*/_createStaticVNode("<div class=\"top7_block2\" data-v-b9d245b4><img src=\"" + _imports_15 + "\" class=\"top7_img1\" data-v-b9d245b4><div class=\"top7_block2_text\" data-v-b9d245b4>专注阅读</div></div><div class=\"top7_block3\" data-v-b9d245b4><img src=\"" + _imports_16 + "\" class=\"top7_img1\" data-v-b9d245b4><div class=\"top7_block3_text\" data-v-b9d245b4><div class=\"top7_text\" data-v-b9d245b4>轻薄便携</div></div></div><div class=\"top7_block4\" data-v-b9d245b4><img src=\"" + _imports_17 + "\" class=\"top7_img1\" data-v-b9d245b4><div class=\"top7_block3_text\" data-v-b9d245b4><div class=\"top7_text\" data-v-b9d245b4>阅读分析</div></div></div>", 3);

var _hoisted_47 = /*#__PURE__*/_createStaticVNode("<div style=\"display:flex;margin-top:33px;\" data-v-b9d245b4><div class=\"top7_block5\" data-v-b9d245b4><img src=\"" + _imports_18 + "\" class=\"top7_img4\" data-v-b9d245b4><div class=\"top7_block3_text\" data-v-b9d245b4><div class=\"top7_text\" data-v-b9d245b4>类纸护眼</div></div></div><div class=\"top7_block6\" data-v-b9d245b4><img src=\"" + _imports_19 + "\" class=\"top7_img5\" data-v-b9d245b4></div></div>", 1);

var _hoisted_48 = /*#__PURE__*/_createStaticVNode("<div class=\"top8\" data-v-b9d245b4><img src=\"" + _imports_20 + "\" class=\"top8_img\" data-v-b9d245b4><div class=\"top8_block\" data-v-b9d245b4><div class=\"top8_block_text1\" data-v-b9d245b4>BC60品质认证</div><div class=\"top8_block_text2\" data-v-b9d245b4> 国际唯一工人健康显示技术电子墨水屏阅读器 </div><div class=\"top8_block_text2\" data-v-b9d245b4> 是国家教育部中央电教馆推荐唯一一款适用于中小学的护眼数字阅读器，引导孩子爱上阅读 </div></div></div><div class=\"top9\" data-v-b9d245b4><div class=\"top9_title\" data-v-b9d245b4>质量标准</div><div class=\"top5_abs\" data-v-b9d245b4> Give consumers greater peace of mind through product quality <br data-v-b9d245b4> testing </div><div style=\"width:100%;display:flex;margin-top:83px;\" data-v-b9d245b4><img src=\"" + _imports_21 + "\" class=\"top9_img\" data-v-b9d245b4><img src=\"" + _imports_22 + "\" class=\"top9_img\" data-v-b9d245b4><img src=\"" + _imports_23 + "\" class=\"top9_img\" data-v-b9d245b4></div></div>", 2);

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", {
    class: "top1_btn animated fadeInUp",
    onClick: _cache[0] || (_cache[0] = function () {
      return _ctx.handleIntroduction && _ctx.handleIntroduction.apply(_ctx, arguments);
    })
  }, _hoisted_9)]), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _hoisted_13, _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
    ref: "top2_block",
    class: _normalizeClass(!_ctx.top1 ? 'top2_block_blue1' : 'top2_block_blue2 animated fadeInUpBig')
  }, null, 2), _hoisted_17])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("img", {
    src: _imports_3,
    class: "top2_img1",
    onClick: _cache[1] || (_cache[1] = function () {
      return _ctx.handleIntroduction && _ctx.handleIntroduction.apply(_ctx, arguments);
    })
  }), _createElementVNode("img", {
    src: _imports_4,
    class: "top2_img1",
    onClick: _cache[2] || (_cache[2] = function () {
      return _ctx.handleIntroduction && _ctx.handleIntroduction.apply(_ctx, arguments);
    })
  }), _createElementVNode("img", {
    src: _imports_5,
    class: "top2_img1",
    onClick: _cache[3] || (_cache[3] = function () {
      return _ctx.handleIntroduction && _ctx.handleIntroduction.apply(_ctx, arguments);
    })
  })]), _createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
    src: _imports_6,
    class: "top2_img2",
    onClick: _cache[4] || (_cache[4] = function () {
      return _ctx.handleIntroduction && _ctx.handleIntroduction.apply(_ctx, arguments);
    })
  })])])]), _hoisted_21, _createElementVNode("div", _hoisted_23, [_hoisted_24, _hoisted_25, _createElementVNode("div", _hoisted_26, [_hoisted_27, _hoisted_28, _hoisted_29, _createElementVNode("div", {
    class: _normalizeClass(_ctx.top2 ? 'top5_block2 animated fadeInUpBig' : 'top5_block2_2'),
    ref: "top5_block2"
  }, null, 2), _hoisted_30]), _hoisted_31]), _hoisted_32, _createElementVNode("div", _hoisted_33, [_hoisted_34, _hoisted_35, _createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_hoisted_39, _createElementVNode("div", {
    class: _normalizeClass(_ctx.top3 ? 'top7_block1_2 animated fadeInRightBig' : 'top7_block1_2_1'),
    ref: "top7_block"
  }, null, 2), _hoisted_40, _hoisted_41, _hoisted_42, _hoisted_43]), _hoisted_44]), _hoisted_47])]), _hoisted_48]);
}